<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>{{ data.title }}</span>
	<span fxFlex="15" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content" style="height: 80vh; overflow: hidden">
	<ngx-doc-viewer [url]="data.url" viewer="google" style="height: 100%"></ngx-doc-viewer>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxFlex="100" fxLayoutAlign="{{ buttonActionLayout }}">
		<button (click)="confirm()" color="primary" mat-raised-button>
			{{ data.confirmButtonText }}
		</button>
		<a (click)="closeDialog()" *ngIf="showCloseButton" mat-button style="color: blue">
			<u>{{ data.cancelButtonText }}</u>
		</a>
	</div>
</mat-dialog-actions>
